import { MetaService } from 'app/services/meta.service';
import { LoaderService } from './../../services/loader.service';
import { ConfigService } from 'app/services/config.service';
import { PageService } from 'app/services/page.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-api-page',
  templateUrl: './api-specification-page.component.html',
  styleUrls: ['./api-specification-page.component.scss'],
  standalone: false,
})
export class ApiSpecificationPageComponent implements OnInit {
  getapikeyInfoModal = false;
  sub: any;
  family: string;
  api: string;
  apiItem;
  embedReady = false;
  constructor(
    public metaService: MetaService,
    private pageService: PageService,
    private route: ActivatedRoute,
    private router: Router,
    private configService: ConfigService
  ) {}

  ngOnInit(): void {
    this.sub = this.route.params.subscribe((params) => {
      this.family = params['family'];
      this.api = params['api'];
      this.embedReady = false;

      this.configService.getConfig('apimatic-products').subscribe(
        (apiMaticProductResponse) => {
          if (apiMaticProductResponse.Items && apiMaticProductResponse.Items.length > 0) {
            const apiMaticProducts = apiMaticProductResponse.Items[0].apimatic;
            apiMaticProducts.forEach((item) => {
              const routeParts = this.router.url.split('/');
              let partToCheck;
              if (item.family) {
                partToCheck = routeParts[3].split('#')[0];
              } else {
                partToCheck = routeParts[2].split('#')[0];
              }
              if (partToCheck === item.name) {
                const secondaryNav = [
                  {
                    title: 'Documentation',
                    path: item.family ? '/apis/' + item.family + '/' + item.name : '/apis/' + item.name,
                  },
                  {
                    title: 'API Specification',
                    path: item.family
                      ? '/api-specification/' + item.family + '/' + item.name
                      : '/api-specification/' + item.name,
                  },
                ];
                const meta = {
                  versions: item.versions,
                  template: 'sdk',
                  title: item.name,
                  'secondary-nav':
                    item['secondary-nav'] && item['secondary-nav'].length > 0 ? item['secondary-nav'] : secondaryNav,
                  'apimatic-spec': true,
                };
                if (item['hide-api-key']) {
                  meta['hide-api-key'] = item['hide-api-key'];
                }
                this.metaService.metadata.next(meta);
                // this.setPortal(item);
                this.apiItem = item;
                this.embedReady = true;
                return;
              }
            });
          }
          // if (!this.isApiMaticSpec) {
          //   this.router.navigateByUrl('/404', { skipLocationChange: true });
          // }
        },
        (error) => {
          this.router.navigateByUrl('/404', { skipLocationChange: true });
        }
      );
    });

    this.pageService.getApiKeyConfirmEvent.subscribe(() => {
      this.getapikeyInfoModal = true;
    });
  }
}
